<template>
  <div class="LoginForm d-flex flex-column h-100">
    <h1 class="text-center mb-4 pb-2">Account aanmaken</h1>
    <div style="min-height: 60px">
      <Feedback :feedback="feedback" />
    </div>
    <Form 
      class="flex-grow-1"
      @submit="handleSubmit">

      <FormField 
        v-model="fields.name.value"
        v-bind="fields.name" />
        
      <FormField 
        v-model="fields.email.value"
        v-bind="fields.email" />
      <FormField 
        v-model="fields.password.value"
        v-bind="fields.password"
        class="mt-2" />
      
      <button 
        type="submit"
        :disabled='isDisabled'
        class="btn btn-success btn-lg btn-block rounded-pill font-weight-bold border-0 mt-3 p-3">
        Aanmaken
      </button>
    </Form>

    <div class="d-flex justify-content-center mt-5">
      <router-link 
        class="text-muted"
        :to="{ name: 'login' }">
        Terug naar login
      </router-link>
    </div>
  </div>
</template>

<script>
import { register } from 'service/auth'

import { required, email } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'

import Feedback from 'atom/Feedback'
import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import fields from 'mixin/fields'

export default {
  name: 'RegistrationForm',
  components: {
    Feedback,
    Form,
    FormField
  },
  mixins: [ fields ],
  data() {
    return {
      feedback: {},
      isDisabled: false,
      fields: {
        name: {
          label: 'Contactpersoon',
          type: 'text',
          placeholder: '',
          value: '',
          validationRules: {
            required
          },
          disabled: false
        },
        email: {
          label: "E-mail",
          autocomplete: "username",
          type: "email",
          placeholder: "naam@bedrijf.nl",
          value: '',
          validationRules: {
            required, email
          },
          disabled: false
        },
        password: {
          label: "Wachtwoord",
          autocomplete: "new-password",
          type: "password",
          value: '',
          validationRules: {
            required
          },
          disabled: false
        }
      }
    }
  },
  methods: {
    ...mapMutations('user', [
      'setUser'
    ]),
    handleSubmit(e) {
      e.preventDefault();
      
      this.disableAllFields()
      this.isDisabled = true
      this.feedback = {
        variant: 'info', 
        message: 'Bezig met registeren...'
      }
      
      register({
        email:    this.fieldValue('email'), 
        password: this.fieldValue('password'),
        data: {
          full_name: this.fieldValue('name'),
          name: this.fieldValue('name')
        }
      })
        .then(() => {
          this.feedback = {
            variant: 'success', 
            message: 'Uw account is aangemaakt. U ontvang een mail ter activatie.'
          }
          // this.setUser({ authenticatedUser: getUser() })
          // this.$router.push({ name: 'login' })
        })
        .catch((err) => {
          this.enableAllFields()

          let msg = (err.json && err.json.error_description) || 
            err.message || 
            err.toString()

          this.isDisabled = false
          if (
            err && 
            err.status === 400 && 
            msg === 'A user with this email address has already been registered'
          ) {
            this.feedback = {
              variant: 'danger', 
              message: 'Dit e-mailadres is reeds in gebruik'
            }
          } else if (err && err.status === 404) {
            this.feedback = {
              variant: 'danger', 
              message: 'Uw gegevens zijn ongeldig'
            }
          } else {
            this.feedback = {
              variant: 'danger', 
              message: 'Onbekende fout. Probeer het later nog eens.'
            }
          }
        })
    },
  }
}
</script>
